import { render, staticRenderFns } from "./JUpload.vue?vue&type=template&id=ebeb7ec6"
import script from "./JUpload.vue?vue&type=script&lang=js"
export * from "./JUpload.vue?vue&type=script&lang=js"
import style0 from "./JUpload.vue?vue&type=style&index=0&id=ebeb7ec6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports